import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environment/environment';

@Injectable({
    providedIn: 'root'
})
export class MediaService {

    baseUrl = environment.baseUrl;

    constructor(private httpService: HttpClient) { }

    uploadMedia(data: any) {
        return this.httpService.post(`${this.baseUrl}backoffice/media/storeMedia`, data);
    }

    deleteMedia(data: any) {
        return this.httpService.post(`${this.baseUrl}backoffice/media/deleteMedia`, data);
    }


}
